var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.assets},_vm._l((_vm.categories),function(ref){
var category = ref.category;
var subText = ref.subText;
var routes = ref.routes;
return _c('div',{key:category,staticClass:"mb-5"},[_c('h1',{class:_vm.$style.assetTitle},[_vm._v(_vm._s(category))]),_c('div',{staticClass:"mb-5"},[_vm._v(_vm._s(subText))]),_c('div',{staticClass:"d-flex flex-wrap justify-center"},_vm._l((routes),function(ref){
var href = ref.href;
var title = ref.title;
var author = ref.author;
return _c('div',{key:title},[_c('a',{attrs:{"href":href,"target":"_blank"}},[_c('v-btn',{staticClass:"mx-2 mt-2",attrs:{"color":"primary"}},[_vm._v(_vm._s(title))])],1),(author)?_c('div',[_vm._v("courtesy of "),_c('a',{attrs:{"href":("https://www.reddit.com" + author),"target":"_blank"}},[_vm._v(_vm._s(author))])]):_vm._e()])}),0)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }